<script>
import Endpoints from '../../../../../../../components/common/Endpoints';
import Common from '../../../../../../../components/common/Common';
import Request from '../../../../../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: (payload) => {
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;
            let data = JSON.parse(JSON.stringify(this.data));
            if (data.total){
                data.total = data.total.toString().split(".").join("").split(",").join(".").split("R$ ").join("");
            }
            Request.do(this, 'POST', Request.getDefaultHeader(this), data, `${Endpoints.orders.updateInfos}${this.order._id}`,
                (response)=>{//SUCCESS CALLBACK
                    state.data._id = response.result._id;
                    state.valuekey += 1;
                    $('#spinner').modal('toggle');
                    this.$emit('confirmation-return', 1);
                    $('#modalOrderService').modal('hide');
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
                    console.log(JSON.stringify(error));
            });
        },
        checkForm: function (e) {
           this.errors = [];
            // if (this.data.companyIsInfosSufficient == null) {
            //     this.errors.push(this.$t('string.orders.information.select.required'));
            // }
            // if (this.data.companyIsInfosSufficient == false) {
            //     if(this.data.companyAddionalInformations == null || this.data.companyAddionalInformations.toString().length<=0){
            //         this.errors.push(this.$t('string.orders.information.msg.required'));
            //     }
            // }

            // if (this.data.companyIsDelivery == null) {
            //     this.errors.push(this.$t('string.orders.delivery.select.required'));
            // }
            
            let total = this.data.total.toString().split(",").join(".").split("R$ ").join("");
            console.log(total);
            // if ((Number(total)<0.01)) {
            //     this.errors.push(this.$t('string.orders.min.value.required'));
            // }
            
            if (this.errors.length>0){
                e.preventDefault();
            }else{
                this.save();
            }
        
        },
        camelize: Common.camelize,
        toUpperCase: Common.toUpperCase,
    }
}
</script>
